import { InjectionToken } from '@angular/core';
import { StateValidator } from '../interfaces/state-validator';

export const STATE_VALIDATORS = new InjectionToken<StateValidator[]>(
    'STATE_VALIDATORS'
);
